/* ZSportsTech — section-pdp-junior.js
   Junior PDP: Size (1–5) × Series (Opener / Middle Order / Power Hitting / Overseas)
   → resolves to the real Model variant. Bound to window.SC_JPDP (emitted by Liquid).
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';
  var root = document.getElementById('sc-jpdp');
  if (!root || !window.SC_JPDP) return;
  var data = window.SC_JPDP.variants || [];
  var sizesEl = document.getElementById('sc-jpdp-sizes');
  var seriesEl = document.getElementById('sc-jpdp-series');
  var profileEl = document.getElementById('sc-jpdp-profile');
  var priceEl = document.getElementById('sc-jpdp-price');
  var addBtn = document.getElementById('sc-jpdp-add');
  var qtyEl = document.getElementById('sc-jpdp-qty');

  function sizeOf(m) { return (m || '').slice(-1); }

  /* Per the Z-Bat detail sheet: Advance is Highest Grade Kashmir in sizes 1–3
     and English Willow in sizes 4–5; Beginner is Kashmir Willow throughout.
     Weight ladders are per model family — 4B runs 30 g heavier per size. */
  var isAdvance = /advance/i.test(window.SC_JPDP.handle || '');
  function willowFor(size) {
    if (!isAdvance) return 'Kashmir Willow';
    return parseInt(size, 10) >= 4 ? 'English Willow' : 'Highest Grade Kashmir Willow';
  }
  var WEIGHTS = {
    '4B': ['720–750 g', '780–810 g', '840–870 g', '900–930 g', '960–990 g'],
    def: ['690–720 g', '750–780 g', '810–840 g', '870–900 g', '930–960 g']
  };
  function weightFor(model, size) {
    var fam = (model || '').slice(0, -1);
    var lad = WEIGHTS[fam] || WEIGHTS.def;
    return lad[parseInt(size, 10) - 1] || '';
  }
  function setText(sel, txt) {
    var els = document.querySelectorAll(sel);
    Array.prototype.forEach.call(els, function (e) { e.textContent = txt; });
  }

  var sizes = [], series = [];
  data.forEach(function (v) {
    var s = sizeOf(v.model);
    if (s && sizes.indexOf(s) === -1) sizes.push(s);
    if (v.series && series.indexOf(v.series) === -1) series.push(v.series);
  });
  sizes.sort();
  var ORDER = ['Opener', 'Middle Order', 'Power Hitting', 'Overseas'];
  series.sort(function (a, b) { return ORDER.indexOf(a) - ORDER.indexOf(b); });

  var state = { size: sizes[0], series: series[0], qty: 1, variant: null };

  /* Deep link: ?model=<modelNo> (e.g. 1B5). Zac and AI Bat Fit link straight to
     the model they recommended, so boot on that model's size AND series rather
     than the first pair — the size alone would land on the wrong series. */
  (function () {
    var wanted = new URLSearchParams(window.location.search).get('model');
    if (!wanted) return;
    var hit = data.filter(function (v) { return v.model === wanted; })[0];
    if (hit) { state.size = sizeOf(hit.model); state.series = hit.series; }
  }());

  function find() {
    return data.filter(function (v) { return sizeOf(v.model) === state.size && v.series === state.series; })[0] || null;
  }
  function bar(l, val) {
    return '<div class="sc-jpdp__bar"><span class="sc-jpdp__bar-l">' + l + '</span>' +
      '<span class="sc-jpdp__bar-track"><span class="sc-jpdp__bar-fill" data-w="' + val + '"></span></span>' +
      '<span class="sc-jpdp__bar-v">' + val + '</span></div>';
  }
  function mkBtn(parent, val, label, group) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sc-jpdp__opt'; b.setAttribute('role', 'radio');
    b.setAttribute('data-val', val); b.textContent = label;
    b.addEventListener('click', function () { if (b.getAttribute('aria-disabled') === 'true') return; state[group] = val; render(); });
    parent.appendChild(b);
  }
  sizes.forEach(function (s) { mkBtn(sizesEl, s, 'Size ' + s, 'size'); });
  series.forEach(function (s) { mkBtn(seriesEl, s, s, 'series'); });

  function paintGroup(el, isActive, isAvailable) {
    Array.prototype.forEach.call(el.children, function (b) {
      var val = b.getAttribute('data-val');
      var on = isActive(val);
      b.setAttribute('aria-checked', String(on));
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-disabled', String(!isAvailable(val)));
    });
  }

  function render() {
    state.variant = find();
    paintGroup(sizesEl, function (v) { return v === state.size; },
      function (v) { return data.some(function (d) { return sizeOf(d.model) === v && d.series === state.series; }); });
    paintGroup(seriesEl, function (v) { return v === state.series; },
      function (v) { return data.some(function (d) { return d.series === v && sizeOf(d.model) === state.size; }); });

    var v = state.variant;
    /* willow tracks the selected size even before a variant resolves */
    setText('.js-jpdp-willow', willowFor(state.size));
    if (v) {
      if (priceEl) priceEl.textContent = v.price;
      /* Points are priced off the variant, so they move with it. */
      if (window.SCPoints) window.SCPoints.update(v.price_c);
      var cmp = document.getElementById('sc-jpdp-compare');
      var save = document.getElementById('sc-jpdp-save');
      var hasCmp = v.compare_c > v.price_c;
      if (cmp) { cmp.hidden = !hasCmp; if (hasCmp) cmp.textContent = v.compare; }
      if (save) { save.hidden = !hasCmp; if (hasCmp) save.textContent = '-' + Math.round((v.compare_c - v.price_c) * 100 / v.compare_c) + '%'; }
      setText('#sc-jpdp-spec-willow', willowFor(state.size));
      setText('#sc-jpdp-spec-weight', weightFor(v.model, state.size));
      setText('#sc-jpdp-spec-size', 'Size ' + state.size);
      setText('#sc-jpdp-spec-model', v.model);
      profileEl.innerHTML = '<p class="sc-jpdp__profile-l">Model ' + v.model + ' · Performance</p>' +
        '<p class="sc-jpdp__profile-m">' + (v.stock ? 'In stock · ready to ship' : 'Made to order') + '</p>' +
        bar('Power', v.power) + bar('Batswing', v.batswing) + bar('Control', v.control) + bar('Feel', v.feel);
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(profileEl.querySelectorAll('.sc-jpdp__bar-fill'), function (f) { f.style.width = f.getAttribute('data-w') + '%'; });
      });
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart · ' + state.series + ' / Size ' + state.size;
    } else {
      profileEl.innerHTML = '<p class="sc-jpdp__profile-m">That size &amp; series combination isn\'t available, pick another.</p>';
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
    }
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-jqty]'), function (b) {
    b.addEventListener('click', function () {
      state.qty = Math.max(1, state.qty + (b.getAttribute('data-jqty') === 'inc' ? 1 : -1));
      qtyEl.textContent = String(state.qty);
    });
  });
  addBtn.addEventListener('click', function () {
    if (addBtn.disabled || !state.variant) return;
    if (window.SCCart) {
      addBtn.textContent = 'Adding…';
      var props = window.SCEngraving ? window.SCEngraving.properties() : {};
      window.SCCart.add(state.variant.id, state.qty, props);
    }
  });

  render();
}());
